import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    padding: '15px 15px 0px',
  },
  ul: {
    padding: '0px',
  },
}));

export default useStyles;
